<!-- Banner -->
<fgb-banner>
  <ng-container *fgbWebsiteContentFeatureFlag="'feature.flag.games'">
    <div class="route-container bg-black">
      <fgb-route-nav indicatorStyle="rounded">
        <a class="nav-item" [routerLink]="['/']" [routerLinkActive]="'active'" [routerLinkActiveOptions]="{ exact: true }">
          <i class="material-icons">flag</i>
          <label>{{ 'home.nav.challenges' | translate : { fgbdefault: 'Challenges' } }}</label>
          <div class="nav-item-bg"></div>
        </a>
        <a class="nav-item" [routerLink]="['/games']" [routerLinkActive]="'active'" [routerLinkActiveOptions]="{ exact: true }">
          <i class="material-icons">sports_esports</i>
          <label>{{ 'home.nav.games' | translate : { fgbdefault: 'Games Hub' } }}</label>
          <div class="nav-item-bg"></div>
        </a>
      </fgb-route-nav>
    </div>
  </ng-container>
</fgb-banner>

<router-outlet></router-outlet>
